import { format, parse, addDays, startOfWeek } from 'date-fns';

type DateWithDay = {
  date: string;
  dayName: string;
};

export const getWeekDatesWithDayNames = (): DateWithDay[] => {
  const currentDate = new Date();
  const startOfCurrentWeek = startOfWeek(currentDate, { weekStartsOn: 1 }); // Monday as the start of the week (ISO 8601)

  const weekDatesWithDayNames: DateWithDay[] = [];

  for (let i = 0; i < 5; i++) {
    const date = addDays(startOfCurrentWeek, i);
    const formattedDate = format(date, 'yyyy-MM-dd');
    const dayName = format(date, 'EEEE');

    weekDatesWithDayNames.push({ date: formattedDate, dayName });
  }

  return weekDatesWithDayNames;
};

export const getDayName = (dateString: string) => {
  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  const dayName = format(date, 'EEEE');

  return dayName;
};

export const getTodaysDayName = () => {
  const todaysDate = new Date();
  return format(todaysDate, 'EEEE');
};
